import { useEffect, useState } from 'react';
import { Row, Col, Modal, Form, Button, Alert } from 'react-bootstrap';
import Boleto from 'boleto.js';
import api from 'api';
import Requesting from 'Requesting';
import { currency, dispatchPixelEvent, googleAdsSend } from 'functions';
import { googleAnalyticsSend } from 'functions';
const ModalBillet = ({
  uuidOffer,
  selectedBumps,
  fbPixels,
  googlePixels,
  googleAds,
  offer,
  coupon,
}) => {
  const [requesting, setRequesting] = useState(true);
  const [error, setError] = useState(null);
  const [billetData, setBilletData] = useState(null);
  const [svgBoleto, setSvgBoleto] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let orderBumps = [];

    selectedBumps.forEach((item) => {
      orderBumps.push(item.uuid);
    });

    let body = {
      offer_id: uuidOffer,
      order_bumps: orderBumps,
      coupon: coupon?.coupon,
    };

    api
      .post('/sales/billet', body)
      .then((r) => {
        setError(null);
        setBilletData(r.data);
        setDueDate(r.data.due);
        if (googlePixels.length > 0) {
          googlePixels.forEach(() => {
            googleAnalyticsSend('purchase', {
              currency: 'BRL',
              value: offer.price,
              transaction_id: r.data.sale_id,
              items: [{ item_name: offer.product.name }],
            });
          });
        }
        if (googleAds.length > 0) {
          googleAds.forEach((item) => {
            if (item.settings.purchase)
              googleAdsSend({
                currency: 'BRL',
                value: offer.price,
                transaction_id: r.data.sale_id,
                send_to: `${item.settings.pixel_id}/${item.settings.purchase_label}`,
              });
          });
        }
      })
      .catch((e) => {
        console.log(e);
        setError(e.response.data);
      })
      .finally(() => {
        setRequesting(false);
      });
  }, []);

  useEffect(() => {
    if (billetData) {
      var line = billetData.line_code.replaceAll(' ', '').replaceAll('.', '');
      var boletojs = new Boleto(line).toSVG();
      setSvgBoleto(boletojs);
      if (fbPixels) {
        fbPixels.forEach((fbp) => {
          dispatchPixelEvent(
            'boleto',
            'Boleto',
            {
              currency: 'BRL',
              value: billetData.amount,
              order_id: billetData.sale_id,
            },
            [fbp]
          );
        });
      }
    }
  }, [billetData, fbPixels]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(billetData.line_code);

    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <>
      <Modal.Header closeButton={!requesting}>
        <b>Pagamento com Boleto Bancário</b>
      </Modal.Header>
      <Modal.Body>
        {requesting && <Requesting />}
        {!requesting && billetData !== null && (
          <Row>
            <Col md={12}>
              <div className='modal-billet'>
                <div className='actions'>
                  <a
                    href={billetData.url}
                    target='_blank'
                    rel='noreferrer'
                    className='btn btn-primary'
                  >
                    <i className='las la-print' />
                    Imprimir boleto
                  </a>
                  <Button
                    onClick={copyToClipboard}
                    variant={!copied ? 'primary' : 'success'}
                  >
                    <i className='las la-copy' />

                    {!copied ? <>Copiar linha digitável</> : 'Copiado!'}
                  </Button>
                </div>
                <div className='mobile'></div>
                <div className='info'>
                  <div>
                    <span className='title'>Valor</span>
                    <span className='value'>{currency(billetData.amount)}</span>
                  </div>
                  <div>
                    <span className='title'>Vencimento</span>
                    <span className='value'>{dueDate}</span>
                  </div>
                </div>
                <div className='code'>
                  <div className='bar-code'>
                    <div
                      id='boleto'
                      dangerouslySetInnerHTML={{
                        __html: svgBoleto,
                      }}
                    ></div>
                  </div>
                  <div className='line'>
                    <Form.Control
                      defaultValue={billetData.line_code}
                      onClick={(e) => {
                        e.target.select();
                        copyToClipboard();
                      }}
                    />
                  </div>
                </div>

                <div className='desktop-line'>{billetData.line_code}</div>
                <div className='payable'>
                  Pagável a Pay42 Intermediacao De Negocios Ltda (CNPJ
                  12.136.889/0001-18)
                </div>
                <div className='instructions'>
                  <span className='title'>Instruções</span>
                  <ul>
                    <li>Você acaba de receber este boleto em seu e-mail.</li>
                    <li>
                      Pagamentos com Boleto Bancário levam até 3 dias úteis para
                      serem compensados e então terem os produtos liberados.
                    </li>
                    <li>
                      Atente-se ao vencimento do boleto. Você pode pagar o
                      boleto em qualquer banco ou casa lotérica até o dia do
                      vencimento.
                    </li>
                    <li>
                      Depois do pagamento, verifique seu e-mail para receber os
                      dados de acesso ao produto (verifique também a caixa de
                      SPAM).
                    </li>
                    <li>
                      <b>Quer receber acesso instantâneo à seu produto?</b>{' '}
                      Escolha pagamento por cartão de crédito ou pix.
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        )}
        {error && (
          <div className='modal-billet'>
            <div className='billet-declined'>
              <div className='text-center'>
                <i className='la la-frown great' style={{ fontSize: '60px' }} />
                <h4>Oops, pera aí</h4>
              </div>
              <p>Sua compra não pode ser concluída.</p>
              <p>
                <Alert variant='danger'>{error.message}</Alert>
              </p>
              <p>Feche esta janela e tente novamente...</p>
              <small>
                Se o problema persistir{' '}
                <a href='https://b4you.com.br/' target='blank'>
                  entre em contato com nosso suporte.
                </a>{' '}
              </small>
            </div>
          </div>
        )}
      </Modal.Body>
    </>
  );
};

export default ModalBillet;
